import useFetchChallengeGroup from '../hooks/useFetchChallengeGroup';
import useHasChallengeCrudPermissions from '../../../utils/hooks/useHasChallengeCrudPermissions';

import ButtonRow from 'lib/src/components/button/ButtonRow';
import LinkButton from '@components/button/LinkButton';

const ChallengeGroupChallengesTableActions = ({ challenge }: any) => {
    const endpoint = `/challenge-groups/${challenge.challengeGroupID}/challenges`;

    const { challengeGroup } = useFetchChallengeGroup(+challenge.challengeGroupID);

    const hasChallengeCrudPermissions = useHasChallengeCrudPermissions(challengeGroup, challenge);

    return (
        <ButtonRow alignment="right">
            <LinkButton color="green" icon="search" href={`${endpoint}/${challenge.id}`}>
                View Details
            </LinkButton>
            {hasChallengeCrudPermissions && (
                <LinkButton color="red" icon="times" href={`${endpoint}/delete/${challenge.id}`}>
                    Remove
                </LinkButton>
            )}
        </ButtonRow>
    );
};

export default ChallengeGroupChallengesTableActions;
